import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { zip } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import { BcConfigService } from 'common/config/provider';
import { GenesysUserPermissionService } from 'common/store/genesys-cloud/users/services/user-permission.service';
import { actualUserLoaded } from '../../../users/actions/user.actions';
import { conversationsTopicName, conversationsTypingTopicName } from '../helpers/conversation-topics';
import { notificationChannelCreated, subscribeToNotifications } from '../../../notifications/actions/notification.actions';
import { GenesysCloudEmailConversationsModulePermissions } from '../../emails/initialize-module.permissions';
import { GenesysCloudMessageConversationsModulePermissions } from '../../messages/initialize-module.permissions';

@Injectable({
  providedIn: 'root'
})
export class ConversationNotificationEffects {
  readonly subscribeToConversationNotifications$ = createEffect(() => {
    const hasAnyPermission$ = this.permissionService.hasAnyPermission$(
      ...GenesysCloudEmailConversationsModulePermissions,
      ...GenesysCloudMessageConversationsModulePermissions
    ).pipe(
      filter(Boolean),
      first()
    );

    return zip(
      this.actions$.pipe(ofType(actualUserLoaded)),
      this.actions$.pipe(ofType(notificationChannelCreated)),
      hasAnyPermission$
    ).pipe(
      first(),
      filter(() => this.configService.isGenesysConversationEnabled()),
      map(([{ user }, { channel }]) => subscribeToNotifications({
        userId: user.id,
        channelId: channel.id,
        topics: [conversationsTopicName(user.id), conversationsTypingTopicName(user.id)]
      }))
    );
  });

  constructor(private readonly actions$: Actions,
              private readonly configService: BcConfigService,
              private readonly permissionService: GenesysUserPermissionService) {
  }
}

